import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppError } from "@obg/ngx.core";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { KycVerificationAction } from "./kyc-verification.action";
import { KycVerificationService } from "./kyc-verification.service";

@Injectable()
export class KycVerificationEffect {
	getKnowYourCustomerUrl$ = createEffect(() =>
		this.actions$.pipe(
			ofType(KycVerificationAction.getKnowYourCustomerUrl),
			switchMap(() =>
				this.service.getKnowYourCustomerUrl().pipe(
					map(KycVerificationAction.getKnowYourCustomerUrlSuccess),
					catchError((error: AppError) => of(KycVerificationAction.getKnowYourCustomerUrlFail(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private service: KycVerificationService
	) {}
}
